import { createClient } from '@supabase/supabase-js';

// Fallback values to prevent crash during preview if .env is missing
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder-project.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key';

if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
  console.warn('Supabase URL oder Key fehlt. App läuft im Demo-Modus mit Platzhalter-Werten.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);